import React from 'react';
import { motion } from 'framer-motion';

const SocialProof = () => (
  <section className="py-20 bg-slate-50 border-y border-slate-200">
    <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
      <div className="text-center mb-12">
        <h3 className="text-sm font-bold text-slate-500 uppercase tracking-widest mb-8">
          Built for B2B Support Operations
        </h3>
        <div className="flex flex-wrap justify-center items-center gap-12 opacity-50 grayscale">
          {['ZENDESK', 'SALESFORCE', 'SERVICENOW', 'FRESHDESK', 'HUBSPOT', 'JIRA'].map((name, i) => (
            <div key={i} className="text-lg font-bold text-slate-800">{name}</div>
          ))}
        </div>
      </div>

      <motion.div
        initial={{ opacity: 0, y: 20 }} whileInView={{ opacity: 1, y: 0 }} viewport={{ once: true }}
        className="max-w-2xl mx-auto text-center"
      >
        <div className="inline-block p-6 rounded-2xl bg-green-50 border border-green-100 mb-6">
          <div className="text-sm font-semibold text-green-800 mb-1">AVERAGE CLIENT RESULT</div>
          <div className="text-5xl font-bold text-green-700">65%</div>
          <div className="text-sm text-green-700 mt-1">Reduction in Tier-1 calls reaching human agents</div>
        </div>
        <p className="text-slate-600 leading-relaxed">
          Our clients don't just save time — they free their best people to focus on complex problems. Routine calls are handled automatically, tickets are created instantly, and nothing falls through the cracks.
        </p>
      </motion.div>
    </div>
  </section>
);

export default SocialProof;